module.exports = __webpack_public_path__ + "img/pro_10.b4bc9359.jpg";